export enum RolesEnum {
  foundation = 'foundation',
  dash = 'dash',
  mcp = 'mcp',
}
